<template>
  <tr>
  
    <td>{{ bookingOrphanOfGroup.customer_name }} <br/> <span style="font-size: 0.8rem;">({{bookingOrphanOfGroup.integration}})</span></td>
    <td>
      {{ bookingOrphanOfGroup.trekksoft_booking_id }} 
      <br/> 
      <span style="font-size: 0.8rem;">({{bookingOrphanOfGroup.id}})</span>
      <!-- show alert on notes/remarks present in this booking -->
      <span v-if="bookingOrphanOfGroup.trekksoft_remarks !== '' && bookingOrphanOfGroup.trekksoft_remarks !== null">
        <br/>
        <i class="fa fa-fw fa-2x fa-exclamation-triangle text-warning" title="Esta reserva tiene notas"></i>
        <button v-b-modal="'show_' + bookingOrphanOfGroup.id" class="mx-1 border" :variant="'light'">Ver notas</button>
      </span>
    </td>
    <td>
      <span>{{bookingOrphanOfGroup.trekksoft_activity_name}}</span> <br/> <span style="margin-left: 10px; color: #777;">({{ bookingOrphanOfGroup.trekksoft_availability_item_name }})</span>
    </td>
    <td>
      {{bookingOrphanOfGroup.trekksoft_availability_item_start}}
    </td>
    <td>
      <span style="text-transform: uppercase">
        {{ bookingOrphanOfGroup.customer_language }}
        <country-flag
          v-if="bookingOrphanOfGroup.customer_language != 'otro'" 
          :country="bookingOrphanOfGroup.customer_language"
          size="small"
        />
        <span v-else>
          ?
        </span>
      </span>
    </td>
    <td>{{ bookingOrphanOfGroup.customer_adults }}</td>
    <td>{{ bookingOrphanOfGroup.customer_children }}</td>
    <td>
      {{
        bookingOrphanOfGroup.customer_adults +
        bookingOrphanOfGroup.customer_children
      }}
    </td>
    <td>
      {{ bookingOrphanOfGroup.agency }} 
      <br> 
      <span style="font-size: 0.8rem;">
        ({{bookingOrphanOfGroup.channel}})
      </span>
    </td>
    <td>{{ bookingOrphanOfGroup.trekksoft_hotel_name }}</td>
    <!-- <td>{{ bookingOrphanOfGroup.trekksoft_hotel_room }}</td> -->
    <td>
      <b-form-select v-model="bookingOrphanOfGroup.value">
        <b-select-option-group label="Grupos CON gestión"></b-select-option-group>
        <option
          v-for="group in groupsWithManagement"
          :key="group.id"
          :label="group.name + ' (' + group.suprazone_name + ')'"
          :value="group.id"
        >
          {{ group.name }} ({{group.suprazone_name}})
        </option>       
        <b-select-option-group label="Grupos sin gestión"></b-select-option-group>
        <option
          v-for="group in groupsWithoutManagement"
          :key="group.id"
          :label="group.name + ' (' + group.suprazone_name + ')'"
          :value="group.id"
        >
          {{ group.name }} ({{group.suprazone_name}})
        </option>      
      </b-form-select> 

      <!-- <v-select
            :options="groupsSorted"
            :reduce="(option) => option.id"
            label="name"
            v-model="bookingOrphanOfGroup.value"
            style="width: 15vw"
        >
          <template v-slot:option="option">
            {{ option.name }} ({{option.suprazone_name}})
          </template>
        </v-select> -->
    </td>
    <td>
      {{ bookingOrphanOfGroup.pickup_point_trekk || 'not set' }} 
      <br> 
      <span style="font-size: 0.8rem;">
        (Time: {{ bookingOrphanOfGroup.pickup_hour_trekk || '?' }})
      </span>
    </td>
    <td>
      <booking-checks-cell :booking="bookingOrphanOfGroup" />
    </td>
    <td class="flex col-1 align-content-center align-items-center align-self-center align">
      <b-button
        :variant="
          bookingOrphanOfGroup.value == undefined ? 'light' : 'dark'
        "
        :disabled="
          bookingOrphanOfGroup.value != undefined ? false : true
        "
        :title="
          bookingOrphanOfGroup.value == undefined
            ? 'Debe elegir una opción'
            : 'Assignar'
        "
        @click="
          assignActivityGroup(bookingOrphanOfGroup.id, bookingOrphanOfGroup.value)
        "
        class="border"
        >
          Asignar
        </b-button>
        
        <show-complete-booking-modal :bookingId="bookingOrphanOfGroup.id" />

        <booking-dropdown-bus-services :booking="bookingOrphanOfGroup" />
    </td>
  </tr>
</template>

<script>
/* eslint-disable */
import Spinner from "vue-spinner/src/ScaleLoader.vue";
import ShowCompleteBookingModal from "../Modal/ShowCompleteBookingModal";
import { mapGetters } from "vuex";
import BookingChecksCell from '../BookingCard/BookingChecksCell.vue';
import BookingDropdownBusServices from '../BookingCard/BookingDropdownBusServices.vue';

export default {
  components: {
    Spinner,
    ShowCompleteBookingModal,
    BookingChecksCell,
    BookingDropdownBusServices
  },
  props: {
    bookingOrphanOfGroup: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      groupsWithManagement: [],
      groupsWithoutManagement: []
    };
  },
  created() {
    this.groupsWithManagement = this.groupsSortedManageSubset
    this.groupsWithoutManagement = this.groupsSortedNoManageSubset
  },
  computed: {
    ...mapGetters(["bookingsUnassigned"]),
    ...mapGetters(['bookingsOrphanGroup']),
    ...mapGetters(["stops"]),
    ...mapGetters(['groups', 'groupsListAdmin']),
    ...mapGetters(['activeTab']),
    ...mapGetters(['activeOption']),
    groupsSorted() {
      return this.groups.sort( (a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1 )
    },
    groupsSortedManageSubset() {
      let grps = this.groups
      grps = grps.sort( (a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1 )
      return grps.filter( (item) => item.manage )
    },
    groupsSortedNoManageSubset() {
      let grps = this.groups
      grps = grps.sort( (a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1 )
      return grps.filter( (item) => !item.manage )
    }
  },
  async mounted() {
    
  },
  methods: {
    
    async assignActivityGroup(bookingId, activityGroupId) {
      if (activityGroupId == "") return;

      const payload = {
        id: bookingId,
        data: {
          activity_group_id: activityGroupId,
        },
      };

      await this.$store.dispatch("bookings/assignActivityGroup", payload);
      this.$notify({
        group: "foo",
        title: "Reserva modificada",
        text: `Se ha asignado la reserva ${bookingId} al grupo de actividad indicado`,
        type: "success",
      });
    },
    async toggleBusService(id, service) {
      const payload = {
        id: id,
        service: service
      }
      await this.$store.dispatch("bookings/toggleBusService", payload)
    },
  },
};
</script>


<style scoped>
#checks_column i, #stop_column i {
  font-size: 14px;
  margin-left: 2px;
}
</style>